module.exports = __webpack_public_path__ + "img/indo-vascular.d2476d1c.png";